import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDrawPolygon, faPen, faRuler } from '@fortawesome/free-solid-svg-icons'
import { kml } from '@tmcw/togeojson'
import dayjs from 'dayjs'
import { getTalhao, TalhaoItens } from '../../../../../services/Talhao'
import { useLogic } from '../../../../../context/useLogic'
import { destroyAlert, errorAlert, loadingAlert } from '../../../../../utils/alert'
import { calculoAreaCoord, getBoundsNoArray } from '../../../../../services/Afins'
import { HeaderDrawer } from '../../../../../Components/CustomUi/headerGaveta'
import { BodyDrawer } from './styles'
import { Render } from '../../../../../Components/CustomUi/render'
import Carregando from '../../../../../Components/CustomUi/loading'
import Input from '../../../../../Components/CustomUi/input'
import KMLUploader from '../../../../../Components/kmlUpload'
import Maps from '../../../../../Components/maps/polygon'
import ButtonCustom from '../../../../../Components/ButtonCustom'
import DesenhoTalhaoNovoNew from '../desenhoTalhaoNovo'

interface PropsFormTalhaoNovo {
  loadingForm: boolean
  update: number
  codPro: number
  nome: string
  setNome: React.Dispatch<React.SetStateAction<string>>
  area: string
  setArea: React.Dispatch<React.SetStateAction<string>>
  selectedFile: null
  setSelectedFile: React.Dispatch<React.SetStateAction<null>>
  kmls: TalhaoItens
  setKml: React.Dispatch<React.SetStateAction<TalhaoItens>>
  atualizar: boolean
  setAtualizar: React.Dispatch<React.SetStateAction<boolean>>
  editPolygon: TypeEditPolygon
  setEditPolygon: React.Dispatch<
    React.SetStateAction<{
      nome: string
      propriedadeCod: number
      propriedadeNome: string
      fitBounds: google.maps.LatLngBounds | google.maps.LatLngBoundsLiteral
      polygon: google.maps.LatLngLiteral[] | google.maps.LatLng[]
    }>
  >
  editNovoPolygon: TypeEditPolygon
  setEditNovoPolygon: React.Dispatch<
    React.SetStateAction<{
      nome: string
      propriedadeCod: number
      propriedadeNome: string
      fitBounds: google.maps.LatLngBounds | google.maps.LatLngBoundsLiteral
      polygon: google.maps.LatLngLiteral[] | google.maps.LatLng[]
    }>
  >
  coordsKml: any[]
  setCoordsKml: React.Dispatch<React.SetStateAction<any[]>>
}

interface TypeEditPolygon {
  nome: string
  propriedadeCod: number
  propriedadeNome: string
  fitBounds: google.maps.LatLngBounds | google.maps.LatLngBoundsLiteral
  polygon: google.maps.LatLngLiteral[] | google.maps.LatLng[]
}

const FormTalhaoNovo: React.FC<PropsFormTalhaoNovo> = ({
  loadingForm,
  update,
  codPro,
  nome,
  setNome,
  area,
  setArea,
  selectedFile,
  setSelectedFile,
  kmls,
  setKml,
  atualizar,
  setAtualizar,
  editPolygon,
  setEditPolygon,
  editNovoPolygon,
  setEditNovoPolygon,
  coordsKml,
  setCoordsKml,
}) => {
  const { responsive } = useLogic()
  const [validoFile, setValidoFile] = useState(false)
  const [criadoPorAtualizadoPor, setCriadoPorAtualizadoPor] = useState<string>('')
  const [modalDesenho, setModalDesenho] = useState(false)

  const handleGetTalhao = async () => {
    try {
      loadingAlert({ msg: 'Carregando talhão...', id: 'load_talhao' })
      const response = await getTalhao(codPro, update)

      if (response.status === 200) {
        const dados = response.data.itens[0]

        setKml(dados)
        dados.arquivo = ''

        // form.setFieldsValue(dados)
        setNome(dados.nome)
        setArea(String(dados.area))
        verificarSeFoiAtualizado(
          dados.create_user,
          dados.create_time,
          dados.update_user,
          dados.update_time
        )

        const areaPolygon = dados.kml.coordenadas.map((item) => {
          return { lat: item.latitude, lng: item.longitude }
        })

        const calcArea = calculoAreaCoord([areaPolygon])
        if (calcArea > 0) {
          setValidoFile(true)
        } else {
          setValidoFile(false)
        }

        setEditPolygon({
          nome: dados.nome,
          propriedadeNome: '',
          propriedadeCod: dados.cod_propriedade,
          fitBounds: getBoundsNoArray(
            dados.kml.coordenadas.map((item) => {
              return { lat: item.latitude, lng: item.longitude }
            })
          ),
          polygon: dados.kml.coordenadas.map((item) => {
            return { lat: item.latitude, lng: item.longitude }
          }),
        })

        // form.setFieldsValue({ area: calcArea })
        setAtualizar(false)
        destroyAlert('load_talhao')
      }
    } catch (error) {
      if (error.response) {
        const { data } = error.response
        errorAlert(data?.error ?? 'Falha na operação!', 7000, 'load_talhao')
      } else {
        errorAlert('Falha na operação! (sem resposta)', 7000, 'load_talhao')
      }
    }
  }

  const verificarSeFoiAtualizado = (create_user, create_time, update_user, update_time) => {
    if (dayjs(update_time).isAfter(dayjs(create_time))) {
      setCriadoPorAtualizadoPor(
        `Atualizado por: ${update_user} em ${dayjs(update_time).format('DD/MM/YYYY HH:mm')}`
      )
    } else {
      setCriadoPorAtualizadoPor(
        `Criado por: ${create_user} em ${dayjs(create_time).format('DD/MM/YYYY HH:mm')}`
      )
    }
  }

  const handleFileUpload = (rawData: string, base64Data) => {
    extractCoordinates(rawData)
    setSelectedFile(base64Data)
  }

  const extractCoordinates = async (kmlString: string) => {
    const parseXmlFromString = async (xmlString: string): Promise<Document> => {
      const parser = new DOMParser()
      const xmlDoc = parser.parseFromString(xmlString, 'application/xml')
      return xmlDoc
    }

    try {
      const domKml = await parseXmlFromString(kmlString)
      const dataGeoJson = kml(domKml)

      const talhoes = []

      const dados = dataGeoJson.features
      const filtrado = dados.filter((data) => data.geometry.type === 'Polygon')

      if (filtrado.length > 0) {
        for (let i = 0; i < filtrado.length; i += 1) {
          const fragment = filtrado[i]
          const talhaoPoly = []

          const coordinates = fragment.geometry.coordinates[0]

          for (let ii = 0; ii < coordinates.length; ii += 1) {
            const coord = coordinates[ii]

            talhaoPoly.push({ lat: coord[1], lng: coord[0] })
          }

          talhoes.push(talhaoPoly)
        }

        const areaCoord = talhoes[0].map((item) => {
          return { lat: item.lat, lng: item.lng }
        })

        const calcArea = calculoAreaCoord([areaCoord])
        if (calcArea <= 0) {
          errorAlert('Arquivo kml inválido!')
          setValidoFile(false)
        } else {
          setValidoFile(true)
        }

        // form.setFieldsValue({ area: calcArea })

        if (update > 0) {
          setEditNovoPolygon({
            nome: kmls.nome,
            propriedadeNome: '',
            propriedadeCod: kmls.cod_propriedade,
            fitBounds: getBoundsNoArray(
              areaCoord.map((item) => {
                return { lat: item.lat, lng: item.lng }
              })
            ),
            polygon: areaCoord.map((item) => {
              return { lat: item.lat, lng: item.lng }
            }),
          })
          setArea(String(calcArea))
        } else {
          setCoordsKml(areaCoord)
          setArea(String(calcArea))
        }
      } else {
        errorAlert('Arquivo kml inválido!')
        setValidoFile(false)
      }
    } catch (error) {
      console.error('Erro ao processar XML:', error)
    }
  }

  const handleChangeMask = (data) => {
    let area = data
    area = area.replace(/([\u0300-\u036f]|[^0-9a-zA-Z\s])/g, '')
    area = (area / 100).toFixed(2).replace('.', ',')
    setArea(area)
  }

  const handleEditContorno = () => {
    setEditPolygon({
      nome: kmls.nome,
      propriedadeNome: '',
      propriedadeCod: kmls.cod_propriedade,
      fitBounds: getBoundsNoArray(
        editNovoPolygon.polygon?.length > 0 ? editNovoPolygon?.polygon : editPolygon?.polygon
      ),
      polygon:
        editNovoPolygon.polygon?.length > 0
          ? editNovoPolygon?.polygon
          : kmls.kml.coordenadas.map((item) => {
              return { lat: item.latitude, lng: item.longitude }
            }),
    })

    setModalDesenho(true)
  }
  const listPropri = () => {
    handleGetTalhao()
    // atualizar(codPro, '')
  }

  // useEffect(() => {
  //     if (atualizar) {
  //       handleGetTalhao()
  //     }
  //   }, [atualizar])

  useEffect(() => {
    if (update > 0) {
      handleGetTalhao()
    }
  }, [update])

  useEffect(() => {
    setEditPolygon({
      nome: kmls?.nome,
      propriedadeNome: '',
      propriedadeCod: kmls?.cod_propriedade,
      fitBounds: getBoundsNoArray(editNovoPolygon?.polygon),
      polygon: editNovoPolygon?.polygon,
    })
  }, [editNovoPolygon])

  return (
    <>
      <HeaderDrawer>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {update ? 'Atualizar talhão' : 'Cadastrar talhão'}

          <small style={{ opacity: '0.5', fontSize: '9px' }}>{criadoPorAtualizadoPor}</small>
        </div>
      </HeaderDrawer>
      <BodyDrawer>
        <Render condition={loadingForm}>
          <Carregando
            animation
            justifyContent='center'
            height={600}
            legenda='Carregando informações...'
          />
        </Render>
        <Render condition={loadingForm === false}>
          <Input
            label='Nome'
            placeholder='Digite o nome do talhão'
            icon={faDrawPolygon}
            value={nome}
            onChange={setNome}
          />
          <Input
            label='Área(ha)'
            placeholder='Digite a área'
            icon={faRuler}
            value={area}
            onChange={handleChangeMask}
          />
          <KMLUploader onFileUpload={handleFileUpload} valido={validoFile} />
          <Render condition={update <= 0}>
            <div className='map-content'>
              {coordsKml.length > 0 ? <Maps coord={coordsKml} /> : null}
            </div>
          </Render>
          <Render condition={validoFile}>
            <div className='map-content'>
              <div className='btn-edit-talhao'>
                <ButtonCustom
                  style={{ backgroundColor: 'white', color: 'green' }}
                  onClick={handleEditContorno}
                  icon={<FontAwesomeIcon icon={faPen} />}
                  // hidden={responsive}
                >
                  Editar desenho
                </ButtonCustom>
              </div>
              {editPolygon.polygon.length > 0 && <Maps coord={editPolygon.polygon} />}
            </div>
          </Render>
        </Render>
        <DesenhoTalhaoNovoNew
          isOpen={modalDesenho}
          update={update}
          cultivavel={false}
          onClose={setModalDesenho}
          onSuccess={listPropri}
          talhao={editPolygon}
          atualizarLista={handleGetTalhao}
        />
      </BodyDrawer>
    </>
  )
}

export default FormTalhaoNovo
